import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coordinadore-main',
  templateUrl: './coordinadore-main.component.html',
  styleUrls: ['./coordinadore-main.component.scss'],
  standalone: false
})
export class CoordinadoreMainComponent implements OnInit {

    selectedIndex: number = 0; // Índice de la pestaña seleccionada por defecto

    // Método para cambiar la pestaña seleccionada
    selectTab(index: number) {
        this.selectedIndex = index;
    }

  constructor() { }

  ngOnInit(): void {
  }

}
